import TrashIcon from "../../Assets/Icons/TrashIcon";

const CartTable = ({
  items = [],
  cartTotal = 0,
  onDelete,

  titleHeader = "Product",
  descriptionHeader = "Product Description",

  // 🔹 NEW FLAG
  isSummerCamp = false,
}) => {
  if (!items?.length) return null;

  return (
    <div className="cart-table">
      <table className="font-antonio">
        <thead>
          <tr>
            <th className="text-clip">{titleHeader}</th>
            <th className="text-clip">{descriptionHeader}</th>
            <th className="text-clip">Total</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {items?.map((item) => (
            <tr key={item.id} className="border-1">
              {/* ===== NAME COLUMN ===== */}
              <td className="pdt-name-first text-clip">
                {isSummerCamp
                  ? item.offering?.name || "Summer Camp"
                  : item.package_name || "Session Package"}
              </td>

              {/* ===== DESCRIPTION COLUMN ===== */}
              <td>
                <div className="product-desc-table">
                  <table border={0}>
                    <tbody>
                      {isSummerCamp ? (
                        <>
                          <tr>
                            <td className="text-clip">
                              Description : {item.offering?.description || "-"}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-clip">
                              Total Players : {item.total_players}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-clip">
                              Total Weeks : {item.total_weeks}
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="text-clip">
                              Session Type : {item.package_name}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-clip">
                              Player Name : {item.child_details?.name}
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </td>

              {/* ===== TOTAL ===== */}
              <td className="weight-800 text-clip">${item.total_price}</td>

              {/* ===== DELETE ===== */}
              <td>
                <span
                  className="delete-item"
                  onClick={() => onDelete(item.id)}
                  style={{ cursor: "pointer" }}
                >
                  <TrashIcon />
                </span>
              </td>
            </tr>
          ))}

          {/* ===== CART TOTAL ===== */}
          <tr className="cart-total-row">
            <td className="cart-total-cstm text-clip">Cart Total</td>
            <td></td>
            <td className="weight-800 text-clip">${cartTotal}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CartTable;
